// extracted by mini-css-extract-plugin
module.exports = {"Right":"Proceedings_Right__2XaYM","Download":"Proceedings_Download__2ZV7d","SciendoBaner":"Proceedings_SciendoBaner__1YAz6"};